function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UseCaseDetailComponent from '@/apps/attributes/modules/use_cases/components/UseCaseDetailComponent';
import { filterMixin } from '@/mixins/filter_mixin';
import { localPaginationMixin } from '@/mixins/local_pagination';
import { useCaseListMixin } from '@/apps/attributes/mixins/use_case_list_mixin';
import { mapState } from 'vuex';
import { ALL_TABLES_OPTION, GA_EVENTS } from '@/js/constants';
import StateComponent from '@/components/StateComponent.vue';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import tasks from '@/js/tasks';
import CalendarComponent from '@/components/CalendarComponent';
import UserSecurityService from '@/apps/data-platform/services/security/user_security_service';
export default {
  name: 'SandboxListPage',
  components: {
    UseCaseDetailComponent: UseCaseDetailComponent,
    StateComponent: StateComponent,
    CalendarComponent: CalendarComponent
  },
  mixins: [filterMixin, localPaginationMixin, useCaseListMixin],
  data: function data() {
    return {
      itemToDelete: null,
      DIALOG_DELETE: 'DIALOG_DELETE',
      DIALOG_SEE_REPORT_DETAIL: 'DIALOG_SEE_REPORT_DETAIL',
      DIALOG_CHANGE_STATUS: 'DIALOG_CHANGE_STATUS',
      DIALOG_SWITCH_OWNER: 'DIALOG_SWITCH_OWNER',
      items: [],
      use_case_name: '',
      creation_date: '',
      search: '',
      text_filter: '',
      organization: null,
      choose_organization: null,
      allOrganizations: ALL_TABLES_OPTION,
      itemToSwitchOwner: null,
      newOwner: null,
      formOK: false,
      rules: {
        new_owner: [function (v) {
          return !!v || 'Campo obligatorio';
        }, function (v) {
          return /.+@.+\..+/.test(v) || 'Debe ser un correo válido';
        }]
      },
      isSwitchingOwner: false
    };
  },
  created: function created() {
    this.organization = this.allOrganizations;
    console.log('created SandboxListPage');
  },
  methods: {
    getUserInfo: function () {
      var _getUserInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(email) {
        var userInfo, domain, company_code, roles;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return UserSecurityService.getUserInfo({
                user_email: email
              });
            case 1:
              userInfo = _context.v;
              domain = userInfo.domain;
              company_code = userInfo.company_info.code;
              roles = userInfo.roles;
              return _context.a(2, {
                roles: roles,
                company_code: company_code,
                domain: domain
              });
          }
        }, _callee);
      }));
      function getUserInfo(_x) {
        return _getUserInfo.apply(this, arguments);
      }
      return getUserInfo;
    }(),
    resetSwitchOwnerDialog: function resetSwitchOwnerDialog() {
      this.itemToSwitchOwner = null;
      this.newOwner = null;
      this.formOK = false;
    },
    openSwitchOwnerDialog: function () {
      var _openSwitchOwnerDialog = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(item) {
        var _this = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.itemToSwitchOwner = item;
              this.newOwner = null;
              this.formOK = false;
              _context2.n = 1;
              return this.$refs[this.DIALOG_SWITCH_OWNER].onOpen();
            case 1:
              this.$nextTick(function () {
                if (_this.$refs.switchOwnerForm) {
                  _this.$refs.switchOwnerForm.resetValidation();
                }
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function openSwitchOwnerDialog(_x2) {
        return _openSwitchOwnerDialog.apply(this, arguments);
      }
      return openSwitchOwnerDialog;
    }(),
    handleSwitchOwnerConfirm: function () {
      var _handleSwitchOwnerConfirm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var userInfoResponse, roles, company_code, domain, company_code_usecase, body, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (this.$refs.switchOwnerForm.validate()) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              this.isSwitchingOwner = true;
              _context3.p = 2;
              _context3.n = 3;
              return this.getUserInfo(this.newOwner);
            case 3:
              userInfoResponse = _context3.v;
              roles = userInfoResponse.roles, company_code = userInfoResponse.company_code, domain = userInfoResponse.domain;
              company_code_usecase = this.itemToSwitchOwner.company_code;
              console.log('company_code_usecase', company_code_usecase, 'company_code', company_code, 'domain', domain);
              if (!(company_code !== company_code_usecase)) {
                _context3.n = 4;
                break;
              }
              tasks.toast.info('El nuevo propietario no pertenece a la misma organización del usuario actual.');
              return _context3.a(2);
            case 4:
              if (roles.includes('attribute_user')) {
                _context3.n = 5;
                break;
              }
              tasks.toast.info('El nuevo propietario no tiene el rol de attribute_user.');
              return _context3.a(2);
            case 5:
              body = {
                old_owner: this.itemToSwitchOwner.owner_name,
                new_owner: this.newOwner
              };
              _context3.n = 6;
              return UseCasesService.switchOwnerUseCase(body, this.itemToSwitchOwner.id);
            case 6:
              tasks.toast.success('Propietario cambiado correctamente');
              this.onSearch();

              // ✅ Cierra el diálogo solo si todo fue exitoso
              this.$refs[this.DIALOG_SWITCH_OWNER].onClose();
              this.resetSwitchOwnerDialog();
              this.$refs.switchOwnerForm.resetValidation();
              _context3.n = 8;
              break;
            case 7:
              _context3.p = 7;
              _t = _context3.v;
              console.error('Error al validar o cambiar propietario:', _t);
              tasks.toast.info('Usuario no encontrado o no es válido');
            case 8:
              _context3.p = 8;
              this.isSwitchingOwner = false; // ✅ Detiene el loading en todos los casos
              return _context3.f(8);
            case 9:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 7, 8, 9]]);
      }));
      function handleSwitchOwnerConfirm() {
        return _handleSwitchOwnerConfirm.apply(this, arguments);
      }
      return handleSwitchOwnerConfirm;
    }(),
    openDeleteDialog: function openDeleteDialog(item) {
      this.itemToDelete = item;
      this.$refs[this.DIALOG_DELETE].onOpen();
    },
    handleDeleteConfirm: function handleDeleteConfirm(confirm) {
      var _this2 = this;
      if (confirm && this.itemToDelete) {
        UseCasesService.deleteResourcesDataset(this.itemToDelete.id).then(function () {
          tasks.toast.success('Eliminado correctamente');
          _this2.onSearch();
        }).catch(function (error) {
          console.error('Error al eliminar:', error.response || error);
          tasks.toast.error('Error al eliminar');
        });
      }
      this.$refs[this.DIALOG_DELETE].onClose();
    },
    openDialog: function openDialog(modalName) {
      this.$refs[modalName].onOpen();
    },
    onCloseDialog: function onCloseDialog(modalName) {
      this.$refs[modalName].onClose();
    },
    onSearch: function onSearch() {
      var selectedOrg = this.choose_organization;
      var organization = this.orgs.find(function (org) {
        return org.domain === selectedOrg;
      });
      var params = {
        user: window.userInfo.email,
        role: '1'
      };
      if (this.use_case_name && this.use_case_name.trim() !== '') {
        params.business_name = this.use_case_name.trim();
      }
      if (this.creation_date) {
        params.creation_date = this.creation_date;
      }
      if (selectedOrg === this.allOrganizations) {
        params.full = '1';
        this.getUseCases(this.companyCode, {
          params: params
        });
      } else if (organization) {
        this.getUseCases(organization.code, {
          params: params
        });
      }
    },
    onResetFilters: function onResetFilters() {
      this.use_case_name = '';
      this.creation_date = '';
      this.choose_organization = this.allOrganizations;
      this.organization = this.allOrganizations;
      this.onSearch();
    },
    onOkObserved: function onOkObserved(valor) {
      var _this3 = this;
      if (valor) {
        var params = {
          status_id: 9,
          company_name: this.companyName,
          response: 'Sandbox observado por el usuario',
          operator: this.userEmail,
          solicitude_type_id: 1
        };
        UseCasesService.updateStatusUseCase(this.useCase.company_code, this.useCase.id, params).then(function (response) {
          if (response && response.data) {
            tasks.toast.success(_this3.translate('success_messages.success_update'), _this3.translate('titles.success'));
          }
        }).catch(function (err) {
          console.error(err);
          tasks.toast.error(_this3.translate('error_messages.error_general'), _this3.translate('titles.error'));
        }).finally(function () {
          _this3.onCloseDialog(_this3.DIALOG_CHANGE_STATUS);
        });
      }
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName', 'orgs'])), mapState('attribute', ['companyAbrevs'])), {}, {
    headers: function headers() {
      return [{
        text: this.translate('table_ownership_history.organization'),
        value: 'organization',
        align: 'start'
      }, {
        text: this.translate('table_ownership_history.use_case'),
        value: 'business_name',
        align: 'start'
      }, {
        text: this.translate('table_ownership_history.owner'),
        value: 'owner_name',
        align: 'start'
      }, {
        text: this.translate('table_ownership_history.date_created'),
        value: 'creation_date',
        align: 'center'
      }, {
        text: this.translate('table_ownership_history.attributes'),
        value: 'attribute_count',
        align: 'end'
      }, {
        text: this.translate('table_ownership_history.status'),
        value: 'status_id',
        align: 'center'
      }, {
        text: '',
        value: 'actions'
      }];
    },
    getOrganizations: function getOrganizations() {
      var list_domains = [];
      list_domains = window.userInfo ? Object.values(window.userInfo.listOrgs) : [];
      list_domains.unshift(window.userInfo.domain);
      list_domains.unshift(ALL_TABLES_OPTION);
      return list_domains;
    },
    totalRecords: function totalRecords() {
      if (this.items.length === 0) {
        return 0;
      } else {
        return this.pagination.total;
      }
    }
  }),
  watch: {
    companyCode: function companyCode(val) {
      if (val) this.onSearch();
    },
    organization: function organization(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.choose_organization = newValue;
        if (newValue === this.allOrganizations) {
          var params = {
            user: window.userInfo.email,
            full: '1',
            role: '1'
          };
          this.getUseCases(this.companyCode, {
            params: params
          });
        } else {
          var organization = this.orgs.find(function (item) {
            return item.domain === newValue;
          });
          if (organization) {
            var _params = {
              user: window.userInfo.email,
              role: '1'
            };
            console.log(_params);
            this.getUseCases(organization.code, {
              params: _params
            });
          }
        }
      }
    }
  }
};